<template>
  <section style="position:relative" id="section">

    <el-row class="statusRow">
      <el-button size="medium" type="primary" @click="addProduct">新增</el-button>
      <el-button size="medium" type="success" @click="changeStatus(false,1)">启用</el-button>
      <el-button size="medium" type="danger" @click="changeStatus(false,0)">禁用</el-button>
       <el-select class="xs24" v-model="pdata.kw" filterable  clearable placeholder="请输入发行游戏名称" >
	        	<el-option v-for="(item,i) in PlacementList" :key="item.issued_app_base_id" :label="item.name" :value="item.name"></el-option>
		      </el-select>
   <!--   <el-button size="medium" type="info" @click="changeStatus(false,-1)">删除</el-button>-->
		
     
		 
    </el-row>
    <!--列表-->
    <el-table
      :data="plist"
      style="width: 100%;"
      stripe
      row-key="id"
      @selection-change="select"
      class="demo-table"
    >
     <el-table-column type="selection" min-width="30px"></el-table-column>
     <el-table-column prop="id" fixed label="ID" min-width="50px" width="50" align="center"></el-table-column>
     <el-table-column prop="name" fixed label="小游戏名称" min-width="50px" align="center" width="350" >
     
     			<template slot-scope="scope">
			<!--		      <el-button size="medium" type="danger" @click="deleteProduce(true,scope.row)">删除</el-button>-->
					      <el-button size="medium" type="text" @click="editRule(scope.row)">{{scope.row.name}}</el-button>
     		 </template>
     </el-table-column>
     <!--<el-table-column prop="appid" fixed label="appid" min-width="50px" align="center" width="180px" ></el-table-column>-->
     <el-table-column prop="name" fixed label="功能点" min-width="50px"  align="left">
     	 <template slot-scope="scope">
          <!--<span v-for="item,index in scope.row.rule">
          	<span class="gn" @mousemove="showGN($event,scope.row,index)" v-if="index==scope.row.rule.length-1" @mouseleave="hideGN($event,scope.row,index)">{{item.name}}</span>
          	<span class="gn" @mousemove="showGN($event,scope.row,index)" v-else @mouseleave="hideGN($event,scope.row,index)">{{item.name}},</span>
          </span>-->
          
          <span v-for="(value, key) in scope.row.rule">
          	<span v-for="(val,k,i) in value" v-if="k=='rule'">
          		<span  class="gn" v-for="cit,cid in val" @mousemove="showGN($event,scope.row,cid,key)" @mouseleave="hideGN($event,scope.row,i,key)" >{{cit.name}},</span>
          	</span>
          </span>
		  	<!--<el-popover
					  ref="popover1"
					  placement="bottom-start"
					  width="400"
					  trigger="click">
				   <p style="font-weight: blod;" v-if="gnTxt.city!=''">屏蔽城市</p>
				   <p v-if="gnTxt.city!=''">{{gnTxt.city}}</p>
				   <p  style="font-weight: blod;" v-if="gnTxt.scene_black!=''">屏蔽黑名单</p>
				   <p v-if="gnTxt.scene_black!=''">{{gnTxt.scene_black}}</p>
				   <p  style="font-weight: blod;" v-if="gnTxt.scene_white!=''">屏蔽白名单</p>
				   <p v-if="gnTxt.scene_white!=''">{{gnTxt.scene_white}}</p>
				</el-popover>-->
        </template>
     </el-table-column>
     




     <el-table-column type="expand" label="SDK配置"  width="80px">
	      <template slot-scope="props">
	      	
	        <el-form label-position="left" inline class="demo-table-expand">
	          <el-form-item label="版本">
	            <span>{{ props.row.review_ver }}</span>
	          </el-form-item>
	          <el-form-item label="路径">
	            <span>{{ props.row.path }}</span>
	          </el-form-item>
	          <el-form-item label="屏蔽城市">
	            <span>{{ props.row.valid_ad_city }}</span>
	          </el-form-item>
	          <el-form-item label="场景值">
	            <span v-if="props.row.valid_ad_scene_white!=''">白名单：{{ props.row.valid_ad_scene_white }}</span>
	            <span v-else="">黑名单：{{props.row.valid_ad_scene_black}}</span>
	          </el-form-item>
	        </el-form>
	        
	      </template>
	    </el-table-column>
     <el-table-column prop="status" fixed label="激活状态" min-width="50px" width="150"  align="center">
     	<template slot-scope="scope">
          <el-button
            size="mini"
            :type="scope.row.status=='1'?'success':'danger'"
            @click="changeStatus(true,scope.row)"
          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
        </template>
     </el-table-column>
     <el-table-column prop="status" fixed label="操作" min-width="50px" width="150"  align="center">
     		 <template slot-scope="scope">
			<!--		      <el-button size="medium" type="danger" @click="deleteProduce(true,scope.row)">删除</el-button>-->
					      <el-button size="medium" type="primary" @click="editRule(scope.row)">编辑</el-button>
					      <el-button type="text"  @click="$router.push({name:'产品日志',params:{index_id:scope.row.id},query:{type:'shieldRule'}})">更新日志</el-button>
     		 </template>
     </el-table-column>
     
    
    </el-table>
    
		<div role="tooltip" id="el-popover-2968" aria-hidden="false" class="el-popover el-popper" tabindex="0" v-if="gnTxt.show"
			style="width: 400px; position: fixed; transform-origin: center top; z-index: 2003;"
			:style="{top:gnTxt.top+'px',left:gnTxt.left+'px'}"
			 x-placement="bottom-start">
			<!---->
		 <p style="font-weight:bold;" v-if="gnTxt.no">序号</p>
	   <p v-if="gnTxt.no">{{gnTxt.no}}</p>
		 <p style="font-weight:bold;" v-if="gnTxt.city">屏蔽城市</p>
	   <p v-if="gnTxt.city">{{gnTxt.city}}</p>
	   <div v-if="gnTxt.scene_black&&gnTxt.scene_white==''">
	   		<p  style="font-weight: bold;" v-if="gnTxt.scene_black&&gnTxt.scene_white==''">屏蔽黑名单</p>
	  		 <p v-if="gnTxt.scene_black!=''">{{gnTxt.scene_black}}</p>
	   </div>
	   <p  style="font-weight: bold;" v-if="gnTxt.scene_white">屏蔽白名单</p>
	   <p v-if="gnTxt.scene_white">{{gnTxt.scene_white}}</p>
	   <p  style="font-weight: bold;" v-if="gnTxt.path_black">屏蔽路径</p>
		 <p v-if="gnTxt.path_black">{{gnTxt.path_black}}</p>	
		 <p  style="font-weight: bold;" v-if="gnTxt.show_num">屏蔽次数</p>
		 <p v-if="gnTxt.show_num">{{gnTxt.show_num}}</p>	
		 <p  style="font-weight: bold;" v-if="gnTxt.show_per">屏蔽概率</p>
		 <p v-if="gnTxt.show_per">{{gnTxt.show_per}}</p>	
		 
		<div x-arrow="" class="popper__arrow" style="left: 8px;"></div>
		
			
		</div>

    <div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>

    <el-dialog
      :title="isAdd?'添加屏蔽规则':'编辑屏蔽规则'"
      :visible.sync="editDialog"
      top="5vh"
      width="1100px"
      custom-class="dialog"
      :close-on-click-modal="false"
    >
      <el-form  :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
      	<el-form-item label="小程序选择" prop="请输入小程序名称">
	      	<el-select v-model="issued_app_id"  placeholder="请输入小程序名称">
				    <el-option
				      v-for="item in PlacementList"
				      :key="item.issued_app_base_id"
				      :label="item.name"
				      :value="item.issued_app_base_id"
				    ></el-option>
				  </el-select>
        
        </el-form-item>

			  <el-tabs type="border-card"  >
			    <el-tab-pane  :label="key" v-for="(value, key, idx) in chooseProduct">
    	      <el-form-item label="APPID" > 
		        	 <el-row :gutter="5" style="margin:0;">
			      		  <el-col :span="6">
										<el-input v-model="value.appid" :placeholder="'请输入'+key+'平台的APPID'"  @input="inputCG('appid',value.appid,key,idx)" ></el-input>
			      		  </el-col>
				      	</el-row>	  
		        </el-form-item>
		  			<el-form-item label="SDK配置">
						  <el-row :gutter="5" style="margin:0;">
			      		  <el-col :span="3">
										    <el-input v-model="value.sdk.review_ver" placeholder="审核版本号" @input="inputCG()"></el-input>
			      		  </el-col>
			      		  <el-col :span="6">
										    <el-input v-model="value.sdk.path" placeholder="路径" @input="inputCG()"></el-input>
			      		  </el-col>
			      		  <el-col :span="6">
										    <el-input v-model="value.sdk.valid_ad_city" placeholder="屏蔽城市" @input="inputCG()"></el-input>
			      		  </el-col>
			      		  <el-col :span="6">
										     <el-input v-if="value.sdk.isWhite"  v-model="value.sdk.valid_ad_scene_white" placeholder="白名单" @input="inputCG()"></el-input>
								 		 		 <el-input v-else  v-model="value.sdk.valid_ad_scene_black" placeholder="黑名单" @input="inputCG()"></el-input>
			      		  </el-col>
			      		  <el-col :span="3">
			      		  			<el-checkbox v-model="value.sdk.isWhite" :checked="value.sdk.isWhite" @change="valid_adWhiteChange(value,idx,key)">白名单</el-checkbox>
			      		  </el-col>
				      </el-row>
				      	<el-row :gutter="5">
			      	</el-row>
						</el-form-item>
						
						<el-form-item label="屏蔽规则" v-for="(item,index) in value.rule" prop="rule">
		        	 <el-row  :gutter="5" style="margin:0;">
		        	 	  <el-col :span="2">
								  	<el-switch
										  v-model="item.status"
										  active-color="#13ce66"
										  @change="statusChange(index)"
										  inactive-color="#f2f2f2">
										</el-switch>
								  </el-col>
								  <el-col :span="2"><div class="grid-content bg-purple-light"><el-input v-model="item.no" placeholder="序号" @input="inputCG()"></el-input></div></el-col>
								  <el-col :span="6"><div class="grid-content bg-purple"><el-input v-model="item.name" placeholder="规则名称" @input="inputCG()"></el-input></div></el-col>
								  <el-col :span="6"><div class="grid-content bg-purple-light"><el-input v-model="item.city" placeholder="屏蔽城市" @input="inputCG()"></el-input></div></el-col>
								  <el-col :span="6"><div class="grid-content bg-purple"></div>
								 		 <el-input v-if="item.isWhite"  v-model="item.scene_white" placeholder="白名单" @input="inputCG()"></el-input>
								 		 <el-input v-else  v-model="item.scene_black" placeholder="黑名单" @input="inputCG()"></el-input>
								  </el-col>
								  <el-col :span="2">
								  	 <el-checkbox v-model="item.isWhite" :checked="item.isWhite" @change="whiteChange(value,index,key)">白名单</el-checkbox>
								  </el-col>
								</el-row>
								 <el-row  :gutter="5" style="margin-top:10px;">
								 	<el-col :span="2">&nbsp;&nbsp;</el-col>
								 	<el-col :span="8"><div class="grid-content bg-purple"><el-input v-model="item.path_black" placeholder="路径" @input="inputCG()"></el-input></div></el-col>
								 	<el-col :span="6"><div class="grid-content bg-purple"><el-input v-model="item.show_num" placeholder="次数" @input="inputCG()"></el-input></div></el-col>
								 	<el-col :span="6"><div class="grid-content bg-purple"><el-input v-model="item.show_per" placeholder="概率" @input="inputCG()"></el-input></div></el-col>
								 	<el-col :span="2">
								 		<div class="grid-content bg-purple-light" style="font-size: 24px; cursor: pointer;"> <i class="el-icon-circle-plus"  @click="addRules(index,key)"></i> <i class="el-icon-remove" v-if="value.rule.length>1"  @click="removeRules(value,index,key)"></i> </div>
								  </el-col>
								 </el-row>
		        </el-form-item>
        
			    </el-tab-pane>
			  
			  </el-tabs>

      	
      	
      
      	
      
			  
			 

       
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import { rulesList, rulesAdd, ruleStatus, splog, rulesEdit ,getIssuedAppBaseList} from "../../api/api";
//import UploadImg from "./uploadImg.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
//  UploadImg
  },
  data() {
    return {
      rules: {
        issued_app_id: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        kw:"",
        theme: "",
        status: "",
        sort_field: "",
        sort_by: "",
        placement:""
      },
      plist: [],
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [], //日志
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText:"请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      },
      imageUrl: "",
      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      }, //修改选中的产品状态,批量修改状态
      selectProduct: [], //批量修改选中的产品
      prWidth: 0,
      option: [], //投放位置配置
      chooseProduct: {
      	"weixin":{
					"appid":"",
        	"sdk":{
		     		"review_ver":'',
						"path":'',
						"valid_ad_city":'',
						"valid_ad_scene_white":'',
						"valid_ad_scene_black":'',
		      	},
		      	"rule":[{status:true, no:'',name:'',city:'',scene_black:'',scene_white:'',isWhite:false,path_black:'',show_num:'',show_per:''}]
				}
      },
      issued_app_id:'',
      index_id:'',
      gnTxt:{
      	no:'',
      	city:'',
      	scene_black:'',
      	scene_white:'',
      	show:false,
      	left:0,
      	top:0,
      },
      get_shield_rule_platform:[],
      applist:[],
      PlacementList:[],
    };
  },
  watch: {
		'pdata.kw':{
			 handler(n, o) {
			 	this.pdata.page=1;
			 	
        this.getList();
      },
      deep: true
		}
  },
  methods: {
  	getPlacements(){
    	getIssuedAppBaseList('', this.$cookie.getCookie("login")).then(res => {

        if (res.code == 200) {
          this.PlacementList = res.data;
          
        }
      });
   },
  	inputCG(str,value,key,index){

  		var reg = /^[0-9a-zA-Z]+$/
  		if(str=='appid'){
  			if(!reg.test(value)){
  				 this.$message.error("appid只能包含数字与字母");
  				 this.chooseProduct[key].appid = '';
  			}
  		}
  		this.$forceUpdate();
  	},
  	whiteChange(value,index,key){
  		
			if(this.chooseProduct[key].rule[index].isWhite==true){
      	 this.chooseProduct[key].rule[index].scene_black='';
      	}
      	else{
      		this.chooseProduct[key].rule[index].scene_white='';
      	}
		  console.log('change',this.chooseProduct[key].rule);
  		
			this.$forceUpdate();
  	},
  	valid_adWhiteChange(value,idx,key){
  
			if(this.chooseProduct[key].sdk.isWhite==true){
				 this.chooseProduct[key].sdk.valid_ad_scene_black='';
			}
			else{
					this.chooseProduct[key].sdk.valid_ad_scene_white='';
			}
			console.log('valid_adWhiteChangechange',this.chooseProduct[key]);
  		this.$forceUpdate();
  	},
  	statusChange(index){
  		console.log('change');
  		
			this.$forceUpdate();
  	},
  	showGN(e,s,i,k){

  		var o=s.rule[k].rule;
  		console.log('show gongneng');
  		this.gnTxt={
  			no:o[i].no,
  			city:o[i].city,
      	scene_black:o[i].scene_black,
      	scene_white:o[i].scene_white,
      	path_black:o[i].path_black,
      	show_num:o[i].show_num,
      	show_per:o[i].show_per,
      	show:true,
      	left:e.pageX,
      	top:e.pageY,
  		}
  	},
  	hideGN(e,s,i,k){
  		this.gnTxt={
  			no:'',
      	city:'',
      	scene_black:'',
      	scene_white:'',
      	path_black:'',
      	show_num:'',
      	show_per:'',
      	show:false,
      	left:0,
      	top:0,
      }
  	},
  	addRules(index,key){
  		
			var o={status:true, no:'',name:'',city:'',scene_black:'',scene_white:'',isWhite:false,path_black:'',show_num:'',show_per:''};
			this.chooseProduct[key].rule.push(o);
			this.$forceUpdate();
  	},
  	removeRules(value,index,key){
  		
  		this.chooseProduct[key].rule.splice(index,1); 
  		this.$forceUpdate();
  		
  	},
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      rulesList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.plist = res.data.list;
          this.maxPage = res.data.max_page;
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
        this.applist = this.$store.applist;
        this.get_shield_rule_platform = this.$store.config.get_shield_rule_platform;
        this.get_shield_rule_platform.forEach((v,i)=>{
        	   var o={
		        	"appid":"",
		        	"sdk":{
				     		"review_ver":'',
								"path":'',
								"valid_ad_city":'',
								"valid_ad_scene_white":'',
								"valid_ad_scene_black":'',
				      	},
				      	"rule":[{status:true, no:'',name:'',city:'',scene_black:'',scene_white:'',isWhite:false,path_black:'',show_num:'',show_per:''}]
			      };
			      this.chooseProduct[v]=o;
			      
        })
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter(s){
    	this.pText = s == "" ? "请选择产品投放位置" : s;
    	this.pdata.placement = s;
    	this.getList();
    },
    search() {
      // this.$refs.input.blur();
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editRule(d) {
      this.editDialog = true;
  
      this.get_shield_rule_platform.forEach((v,i)=>{
        	   var o={
		        	"appid":"",
		        	"sdk":{
				     		"review_ver":'',
								"path":'',
								"valid_ad_city":'',
								"valid_ad_scene_white":'',
								"valid_ad_scene_black":'',
				      	},
				      	"rule":[{status:true, no:'',name:'',city:'',scene_black:'',scene_white:'',isWhite:false,path_black:'',show_num:'',show_per:''}]
			      };
			      
			      this.chooseProduct[v]=o;
			      
        })
     
      this.issued_app_id=d.issued_app_id;
      this.index_id=d.id;
      
      var rule =d.rule;
      for(var i in rule){
      	this.chooseProduct[i]=rule[i];
      	if(this.chooseProduct[i].sdk.valid_ad_scene_white!=''){
	      	 this.chooseProduct[i].sdk.isWhite=true;
	      	 this.chooseProduct[i].sdk.valid_ad_scene_black=''
	      }
	      else{
	      	this.chooseProduct[i].sdk.isWhite=false;
	      }
	      	this.chooseProduct[i].rule.forEach((v,i)=>{
	      	if(v.scene_white!=''){
	      		v.isWhite=true;
	      		v.scene_black='';
	      	}
	      	else{
	      		v.isWhite=false;
	      		v.scene_white='';
	      	}
	      	if(v.status&&v.status==1){
	      			v.status=true;
	      	}
	      	else{
	      		v.status=false;
	      	}
	      })
      }
      this.isAdd = false;
    },
    changeStatus(isSingle, s) {
    	
 
	    	  if (!isSingle && this.selectProduct.length == 0) {
		        this.$message.error("请先选择需要批量操作的数据");
		        return;
		      }
		      if (isSingle) {
		        this.cP.index_id = s.id;
		        this.cP.status = s.status == 1 ? "0" : "1";
		      } else {
		        this.cP.status = s;
		      }
		
		      if (this.cP.status == 0) {
		        this.cP.log =this.getuser+"禁用产品";
		      } else if (this.cP.status == 1) {
		        this.cP.log = this.getuser+"启用产品";
		      } else if (this.cP.status == -1) {
		        this.cP.log = this.getuser+"删除产品";
		      }
		      this.$confirm(this.cP.log+ '该规则, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		      ruleStatus(this.cP, this.$cookie.getCookie("login")).then(res => {
		        if (res.code == 200) {
		          this.getList();
		          this.$message({ message: this.cP.log + "成功", type: "success" });
		        }
		      });
	    	
	    	})
    	
    
      
    },
    deleteProduce(isSingle,s){
    	if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status ='-1';
      }
    	 ruleStatus(this.cP, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.getList();
          this.$message({ message: this.cP.log + "成功", type: "success" });
        }
      });
    	
    },
    addProduct() {
       this.get_shield_rule_platform.forEach((v,i)=>{
        	   var o={
		        	"appid":"",
		        	"sdk":{
				     		"review_ver":'',
								"path":'',
								"valid_ad_city":'',
								"valid_ad_scene_white":'',
								"valid_ad_scene_black":'',
				      	},
				      	"rule":[{status:true, no:'',name:'',city:'',scene_black:'',scene_white:'',isWhite:false,path_black:'',show_num:'',show_per:''}]
			      };
			      this.chooseProduct[v]=o;
			      
        })
      this.editDialog = true;
      this.isAdd = true;
    },
    submit() {

    	for(var i in this.chooseProduct){
	    		if(this.chooseProduct[i].appid==''){
				    			delete this.chooseProduct[i];
				    			continue;
				  }
	    		
			   	var rule=this.chooseProduct[i].rule;
			   	rule.forEach((vv,ii)=>{
					if(vv.status){
						vv.status=1;
					}
					else{
						vv.status=0;
					}
				})
			}
  
//			for(let i=0;i<this.chooseProduct.rule.length;i++){
//			  if(this.chooseProduct.rule[i].no==''||this.chooseProduct.rule[i].city==''||this.chooseProduct.rule[i].name==''){
//			  	 this.$message.error("序号，规则，城市不能为空");
//			     return false
//			  }
//			}

			
//    this.$refs.ruleForm.validate(valid => {
//      if (valid) {
          if (this.isAdd) {
					
          	var p ={
          		"issued_app_id":this.issued_app_id,
          		"rule":encodeURIComponent(JSON.stringify(this.chooseProduct)),
          	}
          	console.log(p);
            rulesAdd(p, this.$cookie.getCookie("login")).then(
              res => {
                if (res.code == 200) {
                	this.$message({
					          message: '添加成功',
					          type: 'success'
					        });
                  this.getList();
                  this.editDialog = false;
                } else {
                  this.$message.error(res.msg);
                }
              }
            );
          } else {
//          this.$prompt("请输入编辑原因", "提示", {
//            confirmButtonText: "确定",
//            cancelButtonText: "取消",
//            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
//            inputErrorMessage: "内容不能为空"
//          }).then(({ value }) => {
              //this.chooseProduct.log = value;
              	var p ={
		          		"issued_app_id":this.issued_app_id,
		          		"rule":encodeURIComponent(JSON.stringify(this.chooseProduct)),
		          		"index_id":this.index_id,
		          	}
              rulesEdit(p, this.$cookie.getCookie("login")).then(
                res => {
                  if (res.code == 200) {
                    this.getList();
                    this.editDialog = false;
                    this.$message({
					          message: '编辑成功',
					          type: 'success'
					        });
					        this.getList();
                  } else {
                    this.$message.error(res.msg);
                  }
                }
              );
//          });
          }
//      }
//      else {
//        return false;
//      }
//    });
    },
    select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
    openDealy(id) {
      splog(id, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getInfo(s) {
      this.chooseProduct = JSON.parse(JSON.stringify(s));
      delete this.chooseProduct.id;
      this.chooseProduct.path='';
      this.chooseProduct.placement=''
      this.chooseProduct.log = "新增复用产品";
      this.chooseTags = this.chooseProduct.tags.split(",");
    },
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  computed: {
	    ...mapGetters([
	    	'getuser'
	    ])
  },
  mounted() {
    this.getList();
    this.getConfig();
    this.getPlacements();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};
</script>
<style scoped lang="scss">
span.gn{
	color: #20A0FF;
	cursor: pointer;
}
.dialog {
  width: 800px;
}
.size {
  width: 100px;
  text-align: right;
  position: absolute;
  top: 20px;
  left: -100px;
  padding-right: 14px;
  box-sizing: border-box;
  color: #999;
  font-size: 12px;
}
</style>

<style >
.demo-table .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    min-width: 200px;
    padding: 0 25px;
}
.demo-table .demo-table-expand label {

    color: #99a9bf;
}
.el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: top;
}
.el-upload-list__item {
  line-height: 0;
}
.selectRow {
  min-width:1200px;padding:15px;background: #fff;
}
.statusRow {
  background: #f2f6fc;
  padding: 15px;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  min-width: 600px;
}
.statusRow > .el-button {
  margin-right: 6px;
}
.gameIcon {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}
.dropdown {
  min-width: 120px;
  width: 170px;
}
.dropdown-menu {
  width: 170px;
  margin: 0 auto;
  text-align: center;
}
.search,
.input {
  width: 220px;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.pageRow {
  min-width: 1200px;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  left: 0;
  bottom: -20px;
  z-index: 1000;
}
@media only screen and (max-width: 767px) {
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 60px;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// Rlist.vue?b12ba598